/* @ngInject */
const mySelectTable = (utils) => {
  return {
    restrict: 'E',
    scope: {
      myData: '=',
    },

    template: require('./mySelectTable.html'),

    /* @ngInject */
    controller: ($scope, utils) => {

    },

    link: (scope, element, attrs) => {

    },
  }
}

export default mySelectTable



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/tables/mySelectTable.js